import styled from 'styled-components';

export const PackageDrawerContainer = styled.div`
    .package-drawer-header-container {
        @media only screen and (max-width: 720px) {
            margin-bottom: 1rem;
        }

        .title-card-wrapper {
            @media only screen and (max-width: 720px) {
                .ant-card-actions {
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    flex: none;
                    li {
                        width: 100% !important;
                        border-right: none;
                        display: flex;
                    }
                }
            }

            .ant-card-head-wrapper {
                /* su mobile le azioni vanno su una riga separata, sotto il titolo */
                @media only screen and (max-width: 720px) {
                    flex-direction: column;
                    align-items: stretch;
                }
            }

            .ant-card-extra {
                @media only screen and (max-width: 720px) {
                    width: 100%;
                    margin: 0 0 0.75rem 0;

                    .nw-dropdown-menu-button-group {
                        justify-content: flex-end;
                    }
                }
            }

            .ant-card-head-title {
                padding: 1.5rem 0;
                font-size: 1.25rem;

                .nw-card-head-title-content {
                    h1 {
                        font-size: 1.5rem;

                        @media only screen and (max-width: 720px) {
                            font-size: 1.1rem;
                        }
                    }
                }
            }

            .package-header {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                padding: 0;

                @media only screen and (max-width: 720px) {
                    flex-direction: column;
                }

                .project-selector-wrapper {
                    border-right: ${(props) => props.theme.DefaultBorder};
                    padding-right: 1rem;
                    margin-right: 1rem;
                    @media only screen and (max-width: 720px) {
                        border-right: none;
                    }
                }

                h1 {
                    flex: 1 1 0;
                    font-size: 1.4rem;
                    font-weight: bold;
                }
            }
        }
        .steps-wrapper {
            flex: 1 1 0;
            margin: 0.25rem 1rem 0.5rem 1rem;

            @media only screen and (max-width: 720px) {
                margin: 0.25rem 0 0.25rem 0;
            }

            .ant-steps-small {
                .ant-steps-item-custom {
                    &.step-disabled {
                        opacity: 0.6;
                    }
                    &.step-warning {
                        .ant-steps-item-icon {
                            & > .ant-steps-icon {
                                color: ${(props) => props.theme.DangerColor} !important;
                            }
                        }
                    }
                    .ant-steps-item-icon {
                        /* su mobile si riduce solo l'icona, non il suo box da 32px:
                           la linea verticale di collegamento resta allineata dov'e' */
                        @media only screen and (max-width: 720px) {
                            margin-right: 0.75rem;
                        }

                        & > .ant-steps-icon {
                            font-size: 1.5rem;

                            @media only screen and (max-width: 720px) {
                                font-size: 1.1rem;
                            }
                        }
                    }
                    .ant-steps-item-content {
                        /* su mobile ogni step sta su una riga sola: titolo e descrizione
                           diventano segmenti in linea, e antd non riserva piu' 48px */
                        @media only screen and (max-width: 720px) {
                            display: flex;
                            flex-wrap: wrap;
                            align-items: baseline;
                            column-gap: 0.4rem;
                            min-height: 0;
                        }

                        .ant-steps-item-title {
                            font-size: 0.9rem;

                            @media only screen and (max-width: 720px) {
                                font-size: 0.8rem;
                                line-height: 1.6rem;
                                padding-right: 0;
                            }
                        }
                        .ant-steps-item-description {
                            font-size: 0.85rem;
                            max-width: none;

                            @media only screen and (max-width: 720px) {
                                font-size: 0.75rem;
                                padding-bottom: 0.5rem;

                                /* la descrizione e il blocco che contiene autore e
                                   department tornano in linea invece che impilati */
                                &,
                                > div {
                                    display: flex;
                                    flex-wrap: wrap;
                                    align-items: baseline;
                                    column-gap: 0.4rem;
                                }

                                /* separatore tra titolo e descrizione... */
                                &::before {
                                    content: '•';
                                    opacity: 0.5;
                                }

                                /* ...e tra i blocchi interni della descrizione */
                                > div > * + *::before {
                                    content: '•';
                                    margin-right: 0.4rem;
                                    opacity: 0.5;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .package-drawer-recipients-container {
        margin: 1.5rem 0 1.5rem 0;
        @media only screen and (max-width: 720px) {
            margin: 0 0 1rem 0;
        }
        .ant-card-head {
            .ant-card-head-title {
                .nw-card-head-title {
                    font-size: 1.25rem;
                    .nw-card-head-title-content {
                        h1 {
                            font-size: 1.25rem;

                            @media only screen and (max-width: 720px) {
                                font-size: 1rem;
                            }
                        }
                    }
                }
            }
        }

        .package-drawer-recipient {
            max-width: 120rem;
            padding: 0.5rem 1rem;

            .package-drawer-recipient-line {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                width: 100%;
                padding: 0;

                p {
                    margin: 0;
                    line-height: 1.2em;
                }

                .package-drawer-recipient-icon {
                    width: 3rem;

                    .recipient-icon {
                        font-size: 1.5rem;
                        opacity: 0.4;
                        .fa-primary {
                            fill: ${(props) => props.theme.TextColor};
                            opacity: 0;
                        }
                        .fa-secondary {
                            fill: ${(props) => props.theme.TextColor};
                            opacity: 0.5;
                        }

                        &.recipient-icon-done {
                            opacity: 1;
                            .fa-primary {
                                fill: #fff;
                                opacity: 1;
                            }
                            .fa-secondary {
                                fill: ${(props) => props.theme.SuccessColor};
                                opacity: 1;
                            }
                        }
                    }
                }
                .package-drawer-recipient-email {
                    padding-right: 2rem;
                    min-width: 20rem;
                    p {
                        font-weight: bold;
                    }
                }
                .package-drawer-recipient-date {
                    min-width: 14rem;
                    p {
                        text-transform: uppercase;
                        font-size: ${(props) => props.theme.FontSizeSm};

                        &.not-visited {
                            font-style: italic;
                            color: ${(props) => props.theme.TextColorMuted};
                            svg {
                                margin-right: 0.5rem;
                            }
                        }
                    }
                }
                .package-drawer-recipient-link {
                    display: flex;
                    align-items: center;
                    min-width: 10rem;
                    flex: 1 1 0;
                    svg {
                        margin-right: 0.25rem;
                    }
                    p {
                        text-transform: uppercase;
                        font-size: ${(props) => props.theme.FontSizeSm};
                        margin-right: 1rem;
                    }
                }
                .package-drawer-recipient-code {
                    display: flex;
                    align-items: center;
                    min-width: 10rem;
                    p {
                        text-transform: uppercase;
                        font-size: ${(props) => props.theme.FontSizeSm};
                        padding-right: 0.5rem;
                    }
                    span {
                        margin-bottom: 0;
                    }
                }

                @media only screen and (max-width: 720px) {
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: flex-start;
                    gap: 0.5rem;
                    position: relative;
                    padding-left: 3rem;

                    .package-drawer-recipient-icon {
                        position: absolute;
                        top: 0;
                        left: 0;
                    }
                    .package-drawer-recipient-code {
                        display: none;
                    }
                }
            }

            .package-drawer-recipient-shortlists {
                display: flex;
                align-items: flex-start;
                justify-content: flex-start;
                width: 100%;
                padding: 0.5rem 0 0 3rem;

                .package-drawer-recipient-shortlists-summary {
                    min-width: 20rem;
                    font-weight: bold;
                }
                .package-drawer-recipient-shortlists-list {
                    flex: 1 1 0;

                    .package-drawer-recipient-shortlist {
                        padding: 1rem 0 0.75rem 0;
                        border-bottom: ${(props) => props.theme.DefaultBorder};
                        &:last-child {
                            border-bottom: none;
                        }
                        //padding top only if not first child
                        &:first-child {
                            padding-top: 0;
                        }
                    }
                }
            }
        }
    }

    .package-drawer-models-container {
        margin: 1rem 0;

        @media only screen and (max-width: 720px) {
            margin: 0 0 1rem 0;
        }

        > .ant-card {
            > .ant-card-head {
                background-color: #fff;
                border-radius: 4px;
                position: sticky;
                top: -1.75rem;
                z-index: 9999;
                min-height: 5rem;

                @media only screen and (max-width: 720px) {
                    position: relative;
                    top: auto;
                }

                .ant-card-head-title {
                    .nw-card-head-title {
                        font-size: 1.25rem;
                        .nw-card-head-title-content {
                            h1 {
                                font-size: 1.25rem;

                                @media only screen and (max-width: 720px) {
                                    font-size: 1rem;
                                }
                            }
                        }
                    }
                }
                .ant-card-extra {
                    .actions-group-holder {
                        padding-top: 0.75rem;

                        .selected-models-actions {
                            padding: 0 4rem 0 0;
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;
                            gap: 2rem;

                            small {
                                display: block;
                                margin-bottom: 0;
                                line-height: 1em;
                                font-size: 0.8rem;
                            }

                            .ant-btn-sm {
                                font-size: 0.8rem;
                            }
                        }
                    }
                }
            }
            > .ant-card-body {
                > .ant-card-body-content {
                    padding: 0.5rem 0 0 0;
                }
            }
        }

        .package-group {
            margin: 0 0 0.5rem 2rem;

            @media only screen and (max-width: 720px) {
                margin: 0 0 0.5rem 0;
            }

            .package-group-wrapper {
                > .ant-card {
                    > .ant-card-head {
                        background-color: #fff;
                        border-radius: 4px;
                        .ant-card-head-title {
                            .nw-card-head-title {
                                .nw-card-head-title-content {
                                    h1 {
                                        font-size: 1.15rem;

                                        @media only screen and (max-width: 720px) {
                                            font-size: 1rem;
                                        }
                                    }
                                }
                            }
                        }

                        @media only screen and (max-width: 720px) {
                            position: sticky;
                            top: 0;
                            z-index: 9999;
                            box-shadow: ${(props) => props.theme.ShadowBelowBottom};
                        }
                    }
                    > .ant-card-body {
                        > .ant-card-body-content {
                            padding: 0.5rem 0 0 0;
                        }
                    }
                }
                .ant-card-extra {
                    @media screen and (max-width: 720px) {
                        width: 100%;
                        padding: 0 1rem;
                    }
                    .actions-group-holder {
                        @media only screen and (max-width: 720px) {
                            width: 100%;
                            justify-content: space-between;
                        }
                    }
                }

                .package-group-models {
                    margin: 0.5rem 0 1.5rem 2rem;

                    @media only screen and (max-width: 720px) {
                        margin: 0.5rem 0 1.5rem 0;
                    }

                    .drag-container {
                        padding-left: 0px;

                        .package-model-draggable {
                            margin-bottom: 0.5rem;
                            display: flex;

                            .package-model-card-wrapper {
                                flex: 1 0 0;

                                .ant-card-head-title {
                                    padding: 0.75rem 0;

                                    .nw-card-head-title-content {
                                        .package-drawer-model-card-title {
                                            padding-left: 1rem;
                                            display: flex;
                                            align-items: center;
                                            justify-content: flex-start;
                                            gap: 0.5rem;

                                            @media only screen and (max-width: 720px) {
                                                padding-left: 0;
                                            }

                                            h2 {
                                                font-size: 1.25rem;
                                                text-transform: capitalize;
                                                margin: 0;

                                                @media only screen and (max-width: 720px) {
                                                    font-size: 1.05rem;
                                                }
                                            }
                                        }
                                    }
                                }
                                /* .ant-card-extra è display:block di default: il suo contenuto
                                   (StyledGroupButton, anch'esso a blocco) si espande a riempire
                                   l'intera riga e schiaccia il titolo a larghezza zero. inline-flex
                                   lo fa restringere al contenuto, lasciando spazio al nome modella. */
                                .ant-card-extra {
                                    display: inline-flex;
                                    width: auto;
                                    flex: 0 0 auto;
                                }
                                .package-drawer-model-card-content {
                                    display: flex;
                                    gap: 1rem;

                                    .package-drawer-model-card-left {
                                        p.package-drawer-model-note {
                                            padding: 0.5rem 1rem;
                                            font-size: 0.9rem;
                                            font-style: italic;
                                        }
                                        flex: 1 1 0;
                                    }
                                    .package-drawer-model-card-right {
                                        .package-drawer-model-card-actions-holder {
                                            display: flex;
                                            flex-direction: column;
                                            gap: 0.25rem;
                                            justify-content: flex-start;
                                            align-items: flex-end;
                                        }
                                        width: 10rem;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .actions-group-holder {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 1rem;
    }
`;
